import React from 'react'
import { MapPin } from 'lucide-react'
import GenericTabelaPage from '../../components/tabelas/GenericTabelaPage'
import { regioesApi } from '../../api/tabelasBasicas'

const RegioesPage: React.FC = () => {
  return (
    <GenericTabelaPage
      titulo="Regiões"
      breadcrumb="Tabelas › Básicas"
      icon={<MapPin size={17} />}
      cdMaxLen={4}
      nmMaxLen={100}
      api={regioesApi}
    />
  )
}

export default RegioesPage
